module.exports = __webpack_public_path__ + "static/media/med_pattern_dark.9db7394f.png";